import React, { useEffect, useState } from "react";
// import { categories } from "../data/category";
import { BiX, BiChevronDown, BiChevronUp } from "react-icons/bi";
import { useNavigate, Link } from "react-router-dom";

// Add your icons
import { IoBagOutline } from "react-icons/io5";
import {
  MdFavoriteBorder,
  MdOutlineBookmarkBorder,
  MdPayment,
} from "react-icons/md";
import { GoPerson } from "react-icons/go";
import { LiaAddressCardSolid } from "react-icons/lia";
import { CiLogout } from "react-icons/ci";
import { PiNumberFiveFill } from "react-icons/pi";
import { getALLCategory } from "../apis/config";
import { useAuth } from "../context/AuthProvider";

const SideBar = ({ onClose }) => {
  const { user } = useAuth();
  const [expandedCategoryIndex, setExpandedCategoryIndex] = useState(null);
  const [expandedSubcategoryIndex, setExpandedSubcategoryIndex] =
    useState(null);
  const navigate = useNavigate();

  const toggleCategory = (index) => {
    setExpandedCategoryIndex(index === expandedCategoryIndex ? null : index);
    setExpandedSubcategoryIndex(null);
  };

  const toggleSubcategory = (index) => {
    setExpandedSubcategoryIndex(
      index === expandedSubcategoryIndex ? null : index
    );
  };

  const [categorys, setCategorys] = useState([]);
  useEffect(() => {
    getALLCategory()
      .then((res) => setCategorys(res.data))
      .catch((err) => console.log(err));
  }, []);
  return (
    <div className="fixed top-0 left-0 w-72 h-full bg-white shadow-2xl z-50 p-4 overflow-y-auto">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">Menu</h2>
        <button onClick={onClose}>
          <BiX size={24} />
        </button>
      </div>
      <div className="flex p-5 gap-5">
        <img
          className="rounded-full"
          src="/assets/ava.jpg"
          width={60}
          height={60}
        />
        <div className="flex flex-col mt-2">
          <h6 className="text-sm font-bold">{user?.name}</h6>
          <span className="text-sm text-primary">{user?.email}</span>
        </div>
      </div>

      {/* Account Dashboard */}
      <div className="text-sm text-gray-800">
        {/* <h3 className="font-bold mb-2">Account</h3> */}
        <div className="flex flex-col gap-3">
          {/* <Link
            to="/account"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <IoBagOutline className="text-xl" /> Orders{" "}
            <PiNumberFiveFill className="ml-auto" />
          </Link>
          <Link
            to="/account/wishlist"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <MdFavoriteBorder className="text-xl" /> Wishlist{" "}
            <PiNumberFiveFill className="ml-auto" />
          </Link>
          <Link
            to="/ticket"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <MdOutlineBookmarkBorder className="text-xl" /> Support Tickets{" "}
            <PiNumberFiveFill className="ml-auto" />
          </Link>
          <Link
            to="/account/profile"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <GoPerson className="text-xl" /> Profile Info
          </Link>
          <Link
            to="/account/address"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <LiaAddressCardSolid className="text-xl" /> Addresses
          </Link>
          <Link
            to="/account/payment"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <MdPayment className="text-xl" /> Payment
          </Link>
          <Link
            to="/logout"
            className="flex items-center gap-2 hover:text-primary"
            onClick={onClose}
          >
            <CiLogout className="text-xl" /> Logout
          </Link> */}
          {/* Divider */}
          <hr className="my-4 border-t border-gray-300" />
          {/* Category Navigation */}
          <ul className="space-y-2">
            {categorys.map((category, catIndex) => (
              <li key={category.name}>
                <div className="flex justify-between w-full items-center font-semibold text-left">
                  <span
                    onClick={() => {
                      navigate(`/category/${category.name}`);
                      onClose();
                    }}
                    className="cursor-pointer hover:text-primary"
                  >
                    {category.name}
                  </span>
                  <button onClick={() => toggleCategory(catIndex)}>
                    {expandedCategoryIndex === catIndex ? (
                      <BiChevronUp />
                    ) : (
                      <BiChevronDown />
                    )}
                  </button>
                </div>

                {expandedCategoryIndex === catIndex && (
                  <ul className="pl-4 mt-2 space-y-2 text-sm text-gray-700">
                    {category.subcategories?.map((sub, subIndex) => (
                      <li key={sub.name}>
                        <div className="flex justify-between items-center">
                          <span
                            className="w-full text-left cursor-pointer hover:text-primary"
                            onClick={() => {
                              navigate(
                                `/category/${category.name}/${sub.name}`
                              );
                              onClose();
                            }}
                          >
                            {sub.name}
                          </span>
                          {sub.types?.length > 0 && (
                            <button onClick={() => toggleSubcategory(subIndex)}>
                              {expandedSubcategoryIndex === subIndex ? (
                                <BiChevronUp />
                              ) : (
                                <BiChevronDown />
                              )}
                            </button>
                          )}
                        </div>

                        {expandedSubcategoryIndex === subIndex &&
                          sub.types?.length > 0 && (
                            <ul className="pl-4 mt-1 text-xs text-gray-500">
                              {sub.types.map((item) => (
                                <li
                                  key={item}
                                  className="hover:text-primary cursor-pointer"
                                  onClick={() => {
                                    navigate(
                                      `/category/${category.name}/${sub.name}`
                                    );
                                    onClose();
                                  }}
                                >
                                  {item.name}
                                </li>
                              ))}
                            </ul>
                          )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
